import { Component, ViewChild } from '@angular/core';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { HeaderService } from '@app/core/services/header.service';
import { TableComponent } from '@shared/components/table/table.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CardComponent } from '@shared/components/card/card.component';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { Observable } from 'rxjs';
import {
  usedVerificationMeterReadingsTable
} from '@shared/table-configs/dashboard/used-verification-meter-readings.table';
import { SortParam } from '@app/core/constants/sort-param';
import { ODataService } from '@app/core/services/odata/odata.service';
import { ODataType } from '@app/core/services/odata/types/odata-type';

@Component({
  selector: 'app-dashboard-used-verification-meter-readings',
  imports: [
    TableComponent,
    CardComponent,
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    TranslatePipe,
    InputDirective,
    ButtonDirective
  ],
  templateUrl: './dashboard-used-verification-meter-readings-component.html',
  styleUrl: './dashboard-used-verification-meter-readings-component.css'
})
export class DashboardUsedVerificationMeterReadingsComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  /** Table **/
  public tableConfig: TableConfig<any> = {
    ...usedVerificationMeterReadingsTable,
    serviceCallback: (pageSize: number, page: number, sort?: SortParam) => this.search(pageSize, page, sort)
  }

  /** Search Form **/
  public searchForm: FormGroup = new FormGroup({
    dayOfWork: new FormControl(),
    meteringPointIdentification: new FormControl(''),
  })

  constructor(
    private readonly oDataService: ODataService,
    private readonly headerService: HeaderService,
  ) {
    this.headerService.setTitle('dashboard.query.usedverificationmeterreadings.title');
  }

  public search(pageSize: number, page: number, sort?: SortParam): Observable<any> {
    const customParams: Record<string, string> = {};

    const dayOfWork = this.searchForm.get('dayOfWork')?.value;
    if (dayOfWork && dayOfWork !== '') {
      customParams['dayOfWork'] = dayOfWork;
    }

    const identification = this.searchForm.get('meteringPointIdentification')?.value;
    if (identification && identification !== '') {
      customParams['meteringPointIdentification'] = identification;
    }

    const query = this.oDataService.dmc.query()
      .paginate(page, pageSize)
      .count();

    if (sort) {
      query.orderBy(`${sort.sortField} ${sort.sortDirection}`);
    }

    for (const [key, value] of Object.entries(customParams)) {
      query.param(key, value);
    }

    return this.oDataService.dmc.getCollection(ODataType.usedVerificationMeterReadings, query);
  }
}
